import { format, formatISO, parseISO } from 'date-fns';
import React, { FC } from 'react';

import s from './index.module.scss';

import { useTrans } from '#root/hooks/use-translation';
import { Keys } from '#root/translations-keys';

export const DateTimeView: FC<{ date: string | undefined; sid: string | undefined }> = ({
  date,
  sid,
}) => {
  const { l } = useTrans();
  const months = l(Keys.generic.months);
  if (!date) {
    console.error('DateTimeView has no date');
    return <></>;
  }

  // Extract only the date part (YYYY-MM-DD) from the date string, to ensure we allways show the correct date even tough the user viewing is in canada etc.
  const dateOnly = date.split('T')[0] ?? date;
  const transformedDate = parseISO(dateOnly);

  return (
    <time dateTime={formatISO(transformedDate)}>
      <div className={s.date}>
        {sid === 'viL2Cu' ? (
          <>
            <div className={s.day}>{format(transformedDate, 'dd')}</div>
            <div className={s.month}>{format(transformedDate, 'MM')}</div>
            <div className={s.year}>{format(transformedDate, 'yyyy')}</div>
          </>
        ) : (
          <>
            <div className={s.day}>{format(transformedDate, 'd')}</div>
            <div className={s.month}>{months[transformedDate.getMonth()]}</div>
            <div className={s.year}>{format(transformedDate, 'yyyy')}</div>
          </>
        )}
      </div>
    </time>
  );
};
